import { styled } from "@mui/system";
import Typography from "@mui/material/Typography";

const PixelTypography = styled(Typography)({
  fontFamily: "VT323",
});

export default PixelTypography;
